export default {
  methods: {
    formatAmount (amount) {
      return Number(Math.round(parseFloat(amount + 'e' + 2)) + 'e-' + 2).toFixed(2)
    },
    parsePrice (price) {
      var parsedPrice = 0
      price = price.replace(',', '.').replace(/[^\d.]/g, '') // price as   "4.1234" / ".25" / "1."
      const priceParts = price.split('.')
      if (priceParts.length > 1) {
        price = priceParts[0] + '.' + priceParts.slice(1).join('')
      }
      const priceFloat = isNaN(parseFloat(price)) ? 0 : parseFloat(price) // 4.1234 /  0.25 /   1
      const priceString = this.getFlooredFixed(priceFloat) // eg:                "4.12" ,  "0.25",  "1.00"

      var [euro, cents] = priceString.split('.') // eg:              ["4", "12"],["0","25"],["1", "00"]
      if (typeof cents === 'undefined') {
        cents = '00'
      }
      cents = cents.substring(0, 2)
      if (cents.length === 1) {
        cents += '0'
      }
      parsedPrice = parseInt(euro, 10)
      parsedPrice += parseInt(cents, 10) / 100
      return parsedPrice
    },
    sanitizePrice: (price) => {
      var sanitizedPrice = price.replace(',', '.').replace(/[^\d.]/g, '')
      const priceParts = sanitizedPrice.split('.')
      if (priceParts.length > 1) {
        sanitizedPrice = priceParts[0] + '.' + priceParts.slice(1).join('').substring(0, 2)
      }
      sanitizedPrice = sanitizedPrice.replace(/^0+(\d)/, '$1')
      return sanitizedPrice
    },
    getFlooredFixed (v) {
      return v.toString().match(/^-?\d+(?:\.\d{0,2})?/)[0]
    }
  }
}
